var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FEEFEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4945_21919",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4945_21919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 13.9999C12.1886 13.9999 12.3469 13.936 12.4747 13.8083C12.6025 13.6805 12.6663 13.5221 12.6663 13.3333C12.6663 13.1444 12.6025 12.986 12.4747 12.8583C12.3469 12.7305 12.1886 12.6666 11.9997 12.6666C11.8108 12.6666 11.6525 12.7305 11.5247 12.8583C11.3969 12.986 11.333 13.1444 11.333 13.3333C11.333 13.5221 11.3969 13.6805 11.5247 13.8083C11.6525 13.936 11.8108 13.9999 11.9997 13.9999ZM11.333 11.3333H12.6663V7.33325H11.333V11.3333ZM5.33301 18.6666V6.66659C5.33301 6.29992 5.46356 5.98603 5.72467 5.72492C5.98579 5.46381 6.29967 5.33325 6.66634 5.33325H17.333C17.6997 5.33325 18.0136 5.46381 18.2747 5.72492C18.5358 5.98603 18.6663 6.29992 18.6663 6.66659V14.6666C18.6663 15.0333 18.5358 15.3471 18.2747 15.6083C18.0136 15.8694 17.6997 15.9999 17.333 15.9999H7.99967L5.33301 18.6666ZM7.43301 14.6666H17.333V6.66659H6.66634V15.4166L7.43301 14.6666Z",
    fill: "#EB3949"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegative);
export default __webpack_public_path__ + "static/media/negative.caabfaaa35d4fa6b2e1b571b69e56ea6.svg";
export { ForwardRef as ReactComponent };